import { render, staticRenderFns } from "./Populars.vue?vue&type=template&id=ef1ac13a&"
import script from "./Populars.vue?vue&type=script&lang=js&"
export * from "./Populars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports